import "./style.css";
import React, { useEffect, useState } from 'react';
import { PopUpAlert } from '../../../components/movableDragDropArea';
import { TextInputField, ButtonFlat, toName } from "../../../components";

import { TaggedList } from "../../../components/TaggedList";
import { BASE_SERVER_URL } from "../../../sampleData";
import axios from "axios";
import { MdAdd, MdOutlineCancel } from "react-icons/md";

export default function AddOnTypes(props) {
    const [alert, setAlert] = useState({});

    return (
    <div className="width-100">
          {Object.keys(alert).length > 0 && (
        <PopUpAlert
          info={alert}
          onClose={() => {
            setAlert({});
          }}
        />
      )}
           <div className="width-100">
                    <header className="golden-card relative">
                      {props.easel ? `Easel Products` : `Pedestal Products`}
                      <div style={{ width: "50px", top: "2px" }} className="float-right">
                        {props.editTypes ? (
                          <MdOutlineCancel
                            className="icon mid"
                            onClick={() => {
                              props.setEditTypes(false);
                            }}
                          />
                        ) : (
                          <MdAdd
                            className="icon mid"
                            onClick={() => {
                              props.setEditTypes(true);
                            }}
                          />
                        )}
                      </div>
                    </header>
                    <div className="row width-100" style={{}}>
                      {(props.types || []).sort().map((each, index) => {
                        return (
                          <div className="col-md-6">
                            <TaggedList
                              text={each}
                              remove={() => {
                                props.editSetting(
                                  {
                                    [props.easel ? `easel_types` : `pedestal_types`]: JSON.stringify(
                                      props.types.filter((e, i) => {
                                        return i !== index;
                                      })
                                    ),
                                  },
                                  function () {
                                    props.setTypes((prev) => {
                                      return prev.filter((e, i) => {
                                        return i !== index;
                                      });
                                    });
                                  }
                                );
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
        </div>
  );
}